import { render, staticRenderFns } from "./TeethSelectorInput.vue?vue&type=template&id=62eae68e&scoped=true"
import script from "./TeethSelectorInput.vue?vue&type=script&lang=js"
export * from "./TeethSelectorInput.vue?vue&type=script&lang=js"
import style0 from "./TeethSelectorInput.vue?vue&type=style&index=0&id=62eae68e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62eae68e",
  null
  
)

export default component.exports